/* v25: one country-only localization POST outside the theme editor, with a five-minute loop guard. */
(function () {
  'use strict';
  var panel = document.querySelector('[data-km-us-context]');
  var context = window.KMThemeContext;
  function inEditor() {
    return !!((context && context.isEditor()) || (window.Shopify && (window.Shopify.designMode || window.Shopify.visualPreviewMode)) ||
      (panel && (panel.dataset.editor === 'true' || panel.dataset.visualPreview === 'true')));
  }
  if (!panel || panel.dataset.country === 'US' || inEditor()) return;
  var form = panel.querySelector('form');
  if (!form || panel.dataset.usAvailable !== 'true') return;
  var key = 'km-us-context-attempt-v21', now = Date.now();
  try {
    var last = Number(sessionStorage.getItem(key) || 0);
    if (last && now - last < 300000) return;
    sessionStorage.setItem(key, String(now));
  } catch (_) { return; } // Manual action remains available to shoppers with blocked storage.
  var field = form.querySelector('[name="return_to"]');
  if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'return_to'; form.appendChild(field); }
  field.value = location.pathname + location.search + location.hash;
  if (!inEditor()) HTMLFormElement.prototype.submit.call(form);
})();
